import { render, staticRenderFns } from "./modalCampaign.vue?vue&type=template&id=07850298&scoped=true"
import script from "./modalCampaign.vue?vue&type=script&lang=js"
export * from "./modalCampaign.vue?vue&type=script&lang=js"
import style0 from "./modalCampaign.vue?vue&type=style&index=0&id=07850298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07850298",
  null
  
)

export default component.exports